import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { I18NextModule } from 'angular-i18next';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { Translate } from '../../utils/translate';
import i18next from 'i18next';
import { RequestStatus } from '../../model/requestStatus.enum';
import { HandlePermissions } from '../../utils/permissions';
import { RequestTypeTranslation } from '../../model/requestType.enum';

//import { OrderResponse } from '../../model/request-list.model';
//import { Authorizations } from '../../model/authorizations.model';

@Component({
  standalone: true,
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    MatCardModule,
    MatIconModule,
    RouterModule
  ]
})
export class CardComponent implements OnChanges {
  @Input() data!: any;
  @Input() cardTitle?: string[];
  @Input() type!: string;

  info: any;
  typeCard = '';
  pendingModel = i18next.t('pendingModel');
  pendingPlate = i18next.t('pendingPlate');
  requestStatusEnum = RequestStatus;
  loanCarPool = '';
  loanLongTerms = '';
  loanWedding = '';

  constructor(
    private router: Router,
    public translate: Translate,
    public handlePermissions: HandlePermissions
  ) {}

  typeCardClass() {
    return this.typeCard === 'requestList' ? 'requestCard' : 'menuCard';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes['data']) {
      this.info = this.data;
      this.updateRequestStatus();
    }
    if (!!changes['type']) {
      this.typeCard = this.type;
    }
  }

  updateRequestStatus() {
    if (this.typeCard === 'requestList') {
      for (const content of this.info) {
        if (
          content.requestStatus === this.requestStatusEnum.NEW_REQUEST ||
          content.requestStatus === this.requestStatusEnum.PENDING_APPROVAL
        ) {
          content.statusGeneric = i18next.t('pendingStatus');
        } else if (
          content.requestStatus === this.requestStatusEnum.APPROVED ||
          content.requestStatus === this.requestStatusEnum.SENT_TO_FACTORY ||
          content.requestStatus === this.requestStatusEnum.IN_PRODUCTION ||
          content.requestStatus ===
            this.requestStatusEnum.PENDING_REGISTRATION ||
          content.requestStatus === this.requestStatusEnum.REGISTERED ||
          content.requestStatus === this.requestStatusEnum.PENDING_ASSIGNMENT ||
          content.requestStatus === this.requestStatusEnum.IN_EXPEDITION ||
          content.requestStatus ===
            this.requestStatusEnum.IN_EXPEDITION_FACTORY ||
          content.requestStatus === this.requestStatusEnum.PENDING_PICK_UP ||
          content.requestStatus === this.requestStatusEnum.ACTIVE
        ) {
          content.statusGeneric = i18next.t('okStatus');
        } else if (
          content.requestStatus === this.requestStatusEnum.CLOSED_REQUEST ||
          content.requestStatus === this.requestStatusEnum.CANCELLED ||
          content.requestStatus === this.requestStatusEnum.REJECTED
        ) {
          content.statusGeneric = i18next.t('koStatus');
        }
      }
    }
  }

  statusStyles(status: string): string {
    if (status === 'Pendiente de aceptación') {
      return 'pending';
    } else if (status === 'Todo correcto') {
      return 'done';
    } else {
      return 'wrong';
    }
  }

  navigateTo(content: any) {
    if (this.type === 'menu') {
      if (typeof content === 'string') {
        this.router.navigateByUrl(content.toLowerCase());
      }
    } else if (this.type === 'requestList') {
      if (content.requestType === RequestTypeTranslation.proyect) {
        this.router.navigate(['/detail-request', content.requestNumber], {
          queryParams: { type: 'PROJECT' }
        });
      } else {
        this.router.navigateByUrl(`detail-request/${content.requestNumber}`);
      }
    } else {
      this.router.navigateByUrl('authorizations');
    }
  }
}
